"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (process.env.BROWSER) {
    require('./index.less');
}
let container;
let timer;
function toast(msg, duration = 1500, isCover = false) {
    if (!container) {
        container = document.createElement('div');
        container.className = 'toast-wrapper';
        document.body.appendChild(container);
    }
    const toastEl = document.createElement('div');
    toastEl.className = 'toast';
    if (isCover) {
        container.innerHTML = '';
        clearTimeout(timer);
    }
    toastEl.textContent = msg;
    container.appendChild(toastEl);
    timer = setTimeout(hideToast, duration, toastEl);
    return () => {
        hideToast(toastEl);
    };
}
exports.default = toast;
function hideToast(el) {
    el.style.opacity = '0';
    setTimeout(removeToast, 1000, el);
}
function removeToast(el) {
    el.parentNode && el.parentNode.removeChild(el);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFO0lBQ3ZCLE9BQU8sQ0FBQyxjQUFjLENBQUMsQ0FBQztDQUN6QjtBQUVELElBQUksU0FBeUIsQ0FBQztBQUM5QixJQUFJLEtBQVUsQ0FBQztBQUNmLFNBQXdCLEtBQUssQ0FBQyxHQUFXLEVBQUUsUUFBUSxHQUFHLElBQUksRUFBRSxPQUFPLEdBQUcsS0FBSztJQUN6RSxJQUFJLENBQUMsU0FBUyxFQUFFO1FBQ2QsU0FBUyxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDMUMsU0FBUyxDQUFDLFNBQVMsR0FBRyxlQUFlLENBQUM7UUFDdEMsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsU0FBUyxDQUFDLENBQUM7S0FDdEM7SUFDRCxNQUFNLE9BQU8sR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzlDLE9BQU8sQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDO0lBQzVCLElBQUksT0FBTyxFQUFFO1FBQ1gsU0FBUyxDQUFDLFNBQVMsR0FBRyxFQUFFLENBQUM7UUFDekIsWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDO0tBQ3JCO0lBQ0QsT0FBTyxDQUFDLFdBQVcsR0FBRyxHQUFHLENBQUM7SUFDMUIsU0FBUyxDQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUMvQixLQUFLLEdBQUcsVUFBVSxDQUFDLFNBQVMsRUFBRSxRQUFRLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDakQsT0FBTyxHQUFHLEVBQUU7UUFDUixTQUFTLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDdkIsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQWxCRCx3QkFrQkM7QUFFRCxTQUFTLFNBQVMsQ0FBQyxFQUFrQjtJQUNuQyxFQUFFLENBQUMsS0FBSyxDQUFDLE9BQU8sR0FBRyxHQUFHLENBQUM7SUFDdkIsVUFBVSxDQUFDLFdBQVcsRUFBRSxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDcEMsQ0FBQztBQUVELFNBQVMsV0FBVyxDQUFDLEVBQWtCO0lBQ3JDLEVBQUUsQ0FBQyxVQUFVLElBQUksRUFBRSxDQUFDLFVBQVUsQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLENBQUM7QUFDakQsQ0FBQyJ9